import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_SEDI } from "@/data/site";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
const DEFAULT = { company: { legal_name: "Nicole Srl" }, sedi: DEFAULT_SEDI, tracking: {} };

export function usePublicSettings() {
  const [data, setData] = useState(DEFAULT);
  useEffect(() => {
    if (!cache) cache = axios.get(`${API}/public/settings`).then((r) => r.data).catch(() => DEFAULT);
    cache.then(setData);
  }, []);
  return data;
}
